const { createReducer } = require('../helpers')
const {
  GET_COUPON_LIST,
  GET_COUPON_LIST_SUCCESS,
  GET_COUPON_LIST_ERROR,
  GET_COUPON_LIST_RESET,
  GET_COUPON,
  GET_COUPON_SUCCESS,
  GET_COUPON_ERROR,
  GET_COUPON_RESET,
  CREATE_COUPON,
  CREATE_COUPON_SUCCESS,
  CREATE_COUPON_ERROR,
  CREATE_COUPON_RESET,
  UPDATE_COUPON,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_ERROR,
  UPDATE_COUPON_RESET,
  DELETE_COUPON,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_ERROR,
  DELETE_COUPON_RESET,
  POST_APPLY_COUPON,
  POST_APPLY_COUPON_SUCCESS,
  POST_APPLY_COUPON_ERROR,
  POST_APPLY_COUPON_RESET,
} = require('./constants')

const initialState = {
  coponList: {
    data: null,
    loading: false,
    error: null,
  },
  copon: {
    data: null,
    loading: false,
    error: null,
  },
  create: {
    data: null,
    loading: false,
    error: null,
  },
  update: {
    data: null,
    loading: false,
    error: null,
  },
  delete: {
    data: null,
    loading: false,
    error: null,
  },
  coupon: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer({

  [GET_COUPON_LIST]: draft => ({
    coponList: {
      ...draft.coponList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_COUPON_LIST_SUCCESS]: (draft, action) => ({
    coponList: {
      ...draft.coponList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_COUPON_LIST_ERROR]: (draft, action) => ({
    coponList: {
      ...draft.coponList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_COUPON_LIST_RESET]: () => ({
    coponList: { ...initialState.coponList },
  }),

  [GET_COUPON]: draft => ({
    copon: {
      ...draft.copon,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_COUPON_SUCCESS]: (draft, action) => ({
    copon: {
      ...draft.copon,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_COUPON_ERROR]: (draft, action) => ({
    copon: {
      ...draft.copon,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_COUPON_RESET]: () => ({
    copon: { ...initialState.copon },
  }),

  [CREATE_COUPON]: draft => ({
    create: {
      ...draft.create,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [CREATE_COUPON_SUCCESS]: (draft, action) => ({
    create: {
      ...draft.create,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CREATE_COUPON_ERROR]: (draft, action) => ({
    create: {
      ...draft.create,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CREATE_COUPON_RESET]: () => ({
    create: { ...initialState.create },
  }),

  [UPDATE_COUPON]: draft => ({
    update: {
      ...draft.update,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_COUPON_SUCCESS]: (draft, action) => ({
    update: {
      ...draft.update,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_COUPON_ERROR]: (draft, action) => ({
    update: {
      ...draft.update,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_COUPON_RESET]: () => ({
    update: { ...initialState.update },
  }),

  [DELETE_COUPON]: draft => ({
    delete: {
      ...draft.delete,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [DELETE_COUPON_SUCCESS]: (draft, action) => ({
    delete: {
      ...draft.delete,
      loading: false,
      data: action.payload.data,
    },
  }),
  [DELETE_COUPON_ERROR]: (draft, action) => ({
    delete: {
      ...draft.delete,
      loading: false,
      error: action.payload.error,
    },
  }),
  [DELETE_COUPON_RESET]: () => ({
    delete: { ...initialState.delete },
  }),


  [POST_APPLY_COUPON]: draft => ({
    coupon: {
      ...draft.coupon,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [POST_APPLY_COUPON_SUCCESS]: (draft, action) => ({
    coupon: {
      ...draft.coupon,
      loading: false,
      data: action.payload,
    },
  }),
  [POST_APPLY_COUPON_ERROR]: (draft, action) => ({
    coupon: {
      ...draft.coupon,
      loading: false,
      error: action.payload,
    },
  }),
  [POST_APPLY_COUPON_RESET]: () => ({
    coupon: { ...initialState.coupon },
  }),

}, initialState)
